<!-- Copyright: Seán I. O'Donoghue -->

<template>
  <a v-if="href" :href="href" class="access-action-btn" @click.prevent="$emit('click')">{{
    label
  }}</a>
  <button v-else type="button" class="access-action-btn" @click="$emit('click')">
    <slot>{{ label }}</slot>
  </button>
</template>

<script setup>
defineProps({
  label: {type: String, required: true},
  href: {type: String, default: ""}
});
defineEmits(["click"]);
</script>

<style scoped>
/* the quiet dark bar of VideoAccessInfoButton: the orange call to action above them is
   "How do I unlock this video?" */
.access-action-btn {
  display: block;
  width: 100%;
  box-sizing: border-box;
  background: #252525;
  color: var(--orange-on-dark);
  border: 1px solid #3a3a3a;
  text-align: center;
  padding: 0.5rem 1rem;
  font-weight: 500;
  font-size: 1rem; /* every width: on phones a 3dvw size shrank it to ~11px (2026-10-14) */
  text-decoration: none;
  cursor: pointer;
}
.access-action-btn:hover {
  background: #2e2e2e;
  border-color: #4a4a4a;
}
/* chosen (a toggle, aria-pressed: /Videos' access categories): green with white text, as a chosen
   filter's tag (DropdownRoutes/Dropdown.vue button.tag.selected, e.g. Keynotes), 2026-10-21 */
.access-action-btn[aria-pressed="true"],
.darkMode .access-action-btn[aria-pressed="true"] {
  color: var(--primary-navigation-color);
  background: var(--brand-color);
  border-color: var(--brand-color);
}
.access-action-btn[aria-pressed="true"]:hover,
.darkMode .access-action-btn[aria-pressed="true"]:hover {
  background: var(--brand-hover-color);
  border-color: var(--brand-hover-color);
}
/* dark mode: #252525 all but vanished on the page's #202124; lighter, with a clear edge
   (2026-10-14) */
.darkMode .access-action-btn {
  background: #36383c;
  border-color: #64676c;
}
.darkMode .access-action-btn:hover {
  background: #404247;
  border-color: #7a7d82;
}
/* wider screens: a touch larger */
@media (min-width: 700px) {
  .access-action-btn {
    font-size: 1.125rem;
  }
}
</style>
